import { render, staticRenderFns } from "./ZTabs.vue?vue&type=template&id=65d81d8c&scoped=true&"
import script from "./ZTabs.vue?vue&type=script&lang=js&"
export * from "./ZTabs.vue?vue&type=script&lang=js&"
import style0 from "./ZTabs.vue?vue&type=style&index=0&id=65d81d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d81d8c",
  null
  
)

component.options.__file = "ZTabs.vue"
export default component.exports